import { createUseStyles } from 'react-jss';

export const addEditTeamStyles = createUseStyles({
  container: {

  },
});
